import type { getAdminPlayersInput } from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAdminPlayers: getAdminPlayersInput;
}

const ADMIN_PLAYERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"admin-players",
	["useGetAdminPlayers"],
);

export { ADMIN_PLAYERS_SERVICE_KEYS };
